class ScriptLoaderService {
    private _cache: Array<string> = [];

    public loadScript(url: string): Promise<unknown> {
        if (this._cache.indexOf(url) > -1) {
            return Promise.resolve();
        }

        return new Promise<void>((resolve) => {
            void $.getScript(url, () => {
                this._cache.push(url);
                resolve();
            });
        });
    }
}

export const scriptLoaderService = new ScriptLoaderService();
